module.exports = __webpack_public_path__ + "img/3.d9b7c61e.png";